/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(
  initialState:
    | { currentUser?: API.CurrentUser; currentMenus?: API.GetWebMenusResult['data'] | undefined }
    | undefined,
) {
  const { currentUser, currentMenus } = initialState ?? {};
  //   const hasRoutes = ['addModel'];
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    normalRouteFilter: (route: any) => {
      // 打印中心判断
      if (route.path?.includes('/print-center') && localStorage.getItem('mhm_token')) {
        return true;
      }

      // 精确匹配：只检查具体的路由权限，不依赖父级菜单
      let result = false;
      currentMenus?.map((item: any) => {
        // 精确匹配一级菜单
        if (item.title === route.name) {
          result = true;
        }

        // 精确匹配二级菜单
        if (item.children && item.children.length > 0) {
          item.children.map((itemChild: any) => {
            if (itemChild.title === route.name) {
              result = true;
            }
          });
        }
      });
      return result;
    },
  };
}
